import React from "react";
import { connect } from "react-redux";
import { Spin, Divider } from "antd";

import IconShortlist from "components/icons/IconShortlist";
import { ACTION_TYPE } from "reducers/actionType";
import NavigationFooter from "components/footers/NavigationFooter";
import { isPopulated, getCategory } from "utils/helpers";
import { BackButton } from "components/ui/MasterButton";

import "styles/CourseAreaDetails.scss";

class CourseAreaDetails extends React.Component {
  handleClick = code => {
    const newCode = code.toString();
    this.props.dispatch({
      type: ACTION_TYPE.COURSE.TOGGLE,
      data: newCode
    });
  };

  getInstName = abbr => this.props.input.institutions[abbr].name;

  render() {
    if (!this.props.input) return <Spin />;
    const { id } = this.props.match.params;
    const { courses, course_prerequisites } = this.props.input;
    const subject_prerequisites = this.props.input.prerequisites;

    const course = courses[id];

    if (!course) {
      return (
        <div className="regular-padding">
          <h1>Course not found</h1>
          <BackButton navlink="/course-areas" />
        </div>
      );
    }

    const { area_of_study } = course;

    const prereqs = course_prerequisites[course.course_code] || {};

    const keys_to_titles = [
      { key: "P", title: "Course prerequisites" },
      { key: "S", title: "Subject prerequisites" },
      { key: "A", title: "Assumed knowledge" },
      { key: "R", title: "Recommended studies" }
    ];

    const { userCourses } = this.props;

    return (
      <>
        <div className="course-area-details padding">
          <BackButton navlink="/course-areas" />
          <div className="course-area-details-heading">
            <span onClick={() => this.handleClick(course.course_code)}>
              <IconShortlist
                selected={userCourses.includes(course.course_code.toString())}
              />
            </span>
            <div>
              <h1
                style={{ marginLeft: 10 }}
                className="course-area-details-title"
              >
                {course.title}
              </h1>
              <h2 className="course-area-details-uni">
                {this.getInstName(course.institution)}
              </h2>
            </div>
          </div>

          <div className="body">
            {area_of_study && (
              <div>
                <div className="title">What you'll study</div>
                <p>{area_of_study}</p>
              </div>
            )}
            {keys_to_titles.map((element, index) => {
              const prerequisites = prereqs[element.key];

              if (!prerequisites || prerequisites.length <= 0) {
                return null;
              }

              return (
                <div key={index}>
                  <Divider />
                  <div className="title">{element.title}</div>
                  {prerequisites
                    .map(id => subject_prerequisites[id].description)
                    .map((prereq, i) => (
                      <p className="no-margin" key={i}>
                        {prereq}
                      </p>
                    ))}
                </div>
              );
            })}
          </div>
        </div>
        <NavigationFooter
          list={true}
          backNavlink="course-areas"
          enable={isPopulated(getCategory("CourseAreas"))}
          nextNavlink="summary"
          final={true}
        />
      </>
    );
  }
}

const mapStateToProps = store => {
  const { userCourses } = store.coursesReducer;
  const { input } = store.inputReducer;
  return { userCourses, input };
};

export default connect(mapStateToProps)(CourseAreaDetails);
